import { memo } from 'react';
import {
  capitalizeFirstLetter,
  lineHeightStyle,
  styledComponent,
} from '../../../../../utils/helpers';
import ChiefComplainDeleteBtn from '../../chiefComplainDeleteBtn';

const SurgicalView = ({
  selectedHistories,
  setSelectedHistories,
  prescriptionItems,
  isDelBtn = true,
}) => {
  let { surgical } = selectedHistories || {};

  // const clearData = (itemName) => {
  //   switch (itemName) {
  //     case 'lucs':
  //       surgical[itemName] = '';
  //       surgical['lucsStatus'] = '';
  //       break;
  //     case 'appendicectomy':
  //       surgical[itemName] = '';
  //       surgical['appendicectomyStatus'] = '';
  //       break;
  //     case 'cholecystectomy':
  //       surgical[itemName] = '';
  //       surgical['cholecystectomyStatus'] = '';
  //       break;
  //     case 'laparotomy':
  //       surgical[itemName] = '';
  //       surgical['laparotomyStatus'] = '';
  //       break;
  //     case 'laparoscopy':
  //       surgical[itemName] = '';
  //       surgical['laparoscopyStatus'] = '';
  //       break;
  //     case 'tah':
  //       surgical[itemName] = '';
  //       surgical['tahStatus'] = '';
  //       break;
  //     case 'ulso':
  //       surgical[itemName] = '';
  //       surgical['ulsoStatus'] = '';
  //       break;
  //     case 'dlso':
  //       surgical[itemName] = '';
  //       surgical['dlsoStatus'] = '';
  //       break;
  //     case 'others':
  //       surgical[itemName] = '';
  //       surgical['othersStatus'] = '';
  //       break;
  //     default:
  //   }
  //   selectedHistories['surgical'] = surgical;
  //   setSelectedHistories({ ...selectedHistories });
  // };

  const clearData = (itemName) => {
    const updatedSurgical = { ...surgical };

    const statusFieldsMap = {
      lucs: 'lucsStatus',
      appendicectomy: 'appendicectomyStatus',
      cholecystectomy: 'cholecystectomyStatus',
      laparotomy: 'laparotomyStatus',
      laparoscopy: 'laparoscopyStatus',
      tah: 'tahStatus',
      ulso: 'ulsoStatus',
      dlso: 'dlsoStatus',
      others: 'othersStatus',
    };

    if (statusFieldsMap[itemName]) {
      updatedSurgical[itemName] = '';
      updatedSurgical[statusFieldsMap[itemName]] = '';
    }

    setSelectedHistories({
      ...selectedHistories,
      surgical: updatedSurgical,
    });
  };

  const Title = styledComponent(
    prescriptionItems?.items?.['history']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['history']?.subItemStyle || {},
  );

  return (
    <div className="breast-exam-view">
      <div className="">S/H</div>
      <ul style={lineHeightStyle('history', prescriptionItems)}>
        {(surgical?.lucsStatus || surgical?.lucs) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <Title>LUCS: {capitalizeFirstLetter(surgical?.lucsStatus)}</Title>
                {surgical?.lucs && <Value> - {surgical?.lucs}</Value>}
              </span>
              <ChiefComplainDeleteBtn action={clearData} itemName={'lucs'} isDelBtn={isDelBtn} />
            </div>
          </li>
        )}
        {(surgical?.appendicectomyStatus || surgical?.appendicectomy) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <Title>Appendicectomy: {capitalizeFirstLetter(surgical?.appendicectomyStatus)}</Title>
                {surgical?.appendicectomy && <Value> - {surgical?.appendicectomy}</Value>}
              </span>
              <ChiefComplainDeleteBtn action={clearData} itemName={'appendicectomy'} isDelBtn={isDelBtn} />
            </div>
          </li>
        )}
        {(surgical?.cholecystectomyStatus || surgical?.cholecystectomy) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <Title>Cholecystectomy: {capitalizeFirstLetter(surgical?.cholecystectomyStatus)}</Title>
                {surgical?.cholecystectomy && <Value> - {surgical?.cholecystectomy}</Value>}
              </span>
              <ChiefComplainDeleteBtn action={clearData} itemName={'cholecystectomy'} isDelBtn={isDelBtn} />
            </div>
          </li>
        )}
        {(surgical?.laparotomyStatus || surgical?.laparotomy) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <Title>Laparotomy: {capitalizeFirstLetter(surgical?.laparotomyStatus)}</Title>
                {surgical?.laparotomy && <Value> - {surgical?.laparotomy}</Value>}
              </span>
              <ChiefComplainDeleteBtn action={clearData} itemName={'laparotomy'} isDelBtn={isDelBtn} />
            </div>
          </li>
        )}
        {(surgical?.laparoscopyStatus || surgical?.laparoscopy) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <Title>Laparoscopy: {capitalizeFirstLetter(surgical?.laparoscopyStatus)}</Title>
                {surgical?.laparoscopy && <Value> - {surgical?.laparoscopy}</Value>}
              </span>
              <ChiefComplainDeleteBtn action={clearData} itemName={'laparoscopy'} isDelBtn={isDelBtn} />
            </div>
          </li>
        )}
        {(surgical?.tahStatus || surgical?.tah) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <Title>Total Abdominal History (TAH): {capitalizeFirstLetter(surgical?.tahStatus)}</Title>
                {surgical?.tah && <Value> - {surgical?.tah}</Value>}
              </span>
              <ChiefComplainDeleteBtn action={clearData} itemName={'tah'} isDelBtn={isDelBtn} />
            </div>
          </li>
        )}
        {(surgical?.ulsoStatus || surgical?.ulso) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <Title>TAH With BLSO: {capitalizeFirstLetter(surgical?.ulsoStatus)}</Title>
                {surgical?.ulso && <Value> - {surgical?.ulso}</Value>}
              </span>
              <ChiefComplainDeleteBtn action={clearData} itemName={'ulso'} isDelBtn={isDelBtn} />
            </div>
          </li>
        )}
        {(surgical?.dlsoStatus || surgical?.dlso) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <Title>TLH With BLSO: {capitalizeFirstLetter(surgical?.dlsoStatus)}</Title>
                {surgical?.dlso && <Value> - {surgical?.dlso}</Value>}
              </span>
              <ChiefComplainDeleteBtn action={clearData} itemName={'dlso'} isDelBtn={isDelBtn} />
            </div>
          </li>
        )}
        {(surgical?.othersStatus || surgical?.others) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <Title>Others: {capitalizeFirstLetter(surgical?.othersStatus)}</Title>
                {surgical?.others && <Value> - {surgical?.others}</Value>}
              </span>
              <ChiefComplainDeleteBtn action={clearData} itemName={'others'} isDelBtn={isDelBtn} />
            </div>
          </li>
        )}
      </ul>
    </div>
  );
};

export default memo(SurgicalView);
